import {AccountMarginSummary} from "../../../models/AccountPerformanceSummary";
import {EquitySummary} from "../models/EquitySummary";
import {IsoDate} from "../../../../pseudo-types/DateTypes";
import {Pair, Predicate} from "../../../../types/GenericTypes";
import {sum} from "../../../../js/util/UtilFunctions";
import {HistoricalEquityTrade, HistoricalEquityTrades} from "../../../models/HistoricalTradeData";
import {ArrayUtil} from "../../../../js/util/ArrayUtil";
import {closingSummary, openingSummary} from "./SummaryCalculatorUtil";

export class EquitySummaryCalculator {

    public static calculate(equities: HistoricalEquityTrades,
                            range: Pair<IsoDate>,
                            marginHistory: ReadonlyArray<AccountMarginSummary>): EquitySummary {

        const startDate = range[0];
        const endDate = range[1];

        const asAtHistory = openingSummary(startDate, marginHistory);
        const currentlyOpenHistory = closingSummary(endDate, marginHistory);

        const tradedEquities = equities.filter(EquitySummaryCalculator.isTradedInPeriod(startDate, endDate));

        const groupedEquities = ArrayUtil.mapBy(tradedEquities, (e) => e.code);

        // Take each underlying, figure out the P&L for each and then sum that up
        const closeValue = Array.from(groupedEquities.values())
                                .map((underlying) => underlying.map((e) => e.value).reduce(sum, 0))
                                .reduce(sum, 0);
        const fees = tradedEquities.map((e) => e.totalFees).reduce(sum, 0);
        const brokerage = tradedEquities.map((e) => e.totalBrokerage).reduce(sum, 0);
        const openValue = currentlyOpenHistory.equityValue;
        const asAtValue = asAtHistory.equityValue;

        const pnl = (openValue - asAtValue) +  closeValue - (brokerage + fees);

        return {
            asAtValue,
            openValue,
            closeValue,
            brokerage,
            fees,
            pnl
        };
    }

    private static isTradedInPeriod(startDate: IsoDate, endDate: IsoDate): Predicate<HistoricalEquityTrade> {
        return (trade) => (trade.tradeDate >= startDate) && (trade.tradeDate <= endDate);
    }
}
